"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContractsAccountActions = void 0;
var ContractsAccountActions = exports.ContractsAccountActions = /*#__PURE__*/function (ContractsAccountActions) {
  ContractsAccountActions["IS_LOADING"] = "api/reducer/IS_CONTRACT_LOADING";
  ContractsAccountActions["LOAD_CURRENT_CONTRACTS"] = "api/reducer/GET_CONTRACTS";
  ContractsAccountActions["SET_SELECTED_CONTRACT"] = "api/reducer/SET_SELECTED_CONTRACT";
  ContractsAccountActions["SET_CONTRACT_WITHOUT_HASH"] = "api/reducer/SET_CONTRACT_WITHOUT_HASH";
  ContractsAccountActions["SET_API_ERROR"] = "api/reducer/SET_API_ERROR";
  return ContractsAccountActions;
}(ContractsAccountActions || {});